module.exports = __webpack_public_path__ + "img/reddit.1e47ebd1.svg";